import React from 'react';

import Quizz from "nm-react-quiz/es/components/Quizz/Quizz";

import Zigzag from "../../UI/Common/Shapes/Zigzag";
import Triangle from "../../UI/Common/Shapes/Triangle";
import DoubleZigzag from "../../UI/Common/Shapes/DoubleZigzag";
import DoubleHalfCircle from "../../UI/Common/Shapes/DoubleHalfCircle";


/**
 * Container used, in article's details page, to display a quizz
 */
const QuizzBlock = (props) => {
    return(
        <div key={props.index} className={props.blockClasses.join(' ')}>
            <div className="title">Quiz !</div>
            <Quizz blockQuizzId={props.quizzId} isLastBlock={props.isLastBlock} />
            <div className="purple-zigzag">
                <Zigzag color="#241459" />
            </div>
            <div className="pink-triangle">
                <Triangle color="#ff8377" rotateAngle="-50" />
            </div>
            <div className="dual-zigzag">
                <DoubleZigzag color1='#30e6ca' color2='#ff8377' rotateAngle="-35"/>
            </div>
            <div className="dual-half-circle">
                <DoubleHalfCircle color1='#eee' color2='#fcea10' rotateAngle="-95"/>
            </div>

        </div>
    );
}

export default QuizzBlock;



// WEBPACK FOOTER //
// ./src/containers/Article/Details/QuizzBlock.js